<template>
  <div>
    <Card>
      <div class="theme-item-content">
        <h3 class="title">{{ $t("sideMenu") }}</h3>
        <div class="checkbox-content">
          <Tooltip transfer placement="top" :content="$t('darkblue')">
            <div
              class="checkbox-item checkbox-item-darkblue"
              @click="changeMenuTheme('darkblue')"
            >
              <Icon
                type="md-checkmark"
                class="checkbox-select-icon"
                v-if="menuTheme == 'darkblue'"
              />
            </div>
          </Tooltip>
          <Tooltip placement="top" :content="$t('dark')">
            <div
              class="checkbox-item checkbox-item-black"
              @click="changeMenuTheme('black')"
            >
              <Icon
                type="md-checkmark"
                class="checkbox-select-icon"
                v-if="menuTheme == 'black'"
              />
            </div>
          </Tooltip>
          <Tooltip placement="top" :content="$t('middle')">
            <div
              class="checkbox-item checkbox-item-dark"
              @click="changeMenuTheme('dark')"
            >
              <Icon
                type="md-checkmark"
                class="checkbox-select-icon"
                v-if="menuTheme == 'dark'"
              />
            </div>
          </Tooltip>
          <Tooltip placement="top" :content="$t('white')">
            <div
              class="checkbox-item checkbox-item-side-light"
              @click="changeMenuTheme('light')"
            >
              <Icon
                type="md-checkmark"
                class="checkbox-select-icon"
                v-if="menuTheme == 'light'"
              />
            </div>
          </Tooltip>
        </div>
      </div>
      <div class="theme-item-content">
        <h3 class="title">{{ $t("navMenu") }}</h3>
        <div class="checkbox-content">
          <Tooltip transfer placement="top" :content="$t('darkblue')">
            <div
              class="checkbox-item checkbox-item-nav-darkblue checkbox-item-nav"
              @click="changeNavTheme('darkblue')"
            >
              <Icon
                type="md-checkmark"
                class="checkbox-select-icon"
                v-if="navTheme == 'darkblue'"
              />
            </div>
          </Tooltip>
          <Tooltip placement="top" :content="$t('dark')">
            <div
              class="checkbox-item checkbox-item-nav-black checkbox-item-nav"
              @click="changeNavTheme('black')"
            >
              <Icon
                type="md-checkmark"
                class="checkbox-select-icon"
                v-if="navTheme == 'black'"
              />
            </div>
          </Tooltip>
          <Tooltip placement="top" :content="$t('lightblue')">
            <div
              class="checkbox-item checkbox-item-nav-primary checkbox-item-nav"
              @click="changeNavTheme('primary')"
            >
              <Icon
                type="md-checkmark"
                class="checkbox-select-icon"
                v-if="navTheme == 'primary'"
              />
            </div>
          </Tooltip>
          <Tooltip placement="top" :content="$t('white')">
            <div
              class="checkbox-item checkbox-item-nav-light checkbox-item-nav"
              @click="changeNavTheme('light')"
            >
              <Icon
                type="md-checkmark"
                class="checkbox-select-icon"
                v-if="navTheme == 'light'"
              />
            </div>
          </Tooltip>
        </div>
      </div>
      <Form ref="form" :model="form" :label-width="125" label-position="left">
        <FormItem label="Logo：">
          <upload-pic-thumb
            v-model="form.logoUrl"
            :multiple="false"
            @on-change="changeLogo"
          ></upload-pic-thumb>
        </FormItem>
        <FormItem label="系统名称：" v-if="orgId != 'DEFAULT'">
          <Input
            v-model="form.systemName"
            @on-change="changeSysName"
            style="width: 300px"
          />
        </FormItem>
        <FormItem label="名称字号(px)：" v-if="orgId != 'DEFAULT'">
          <Input
            v-model="form.fontSize"
            @on-change="changeFontSize"
            style="width: 300px"
          />
        </FormItem>
        <FormItem label="是否显示标签栏：">
          <i-switch
            :value="showTags"
            @on-change="changeShowTags"
            size="small"
          />
        </FormItem>
        <FormItem label="默认首页路径：">
          <Input
            v-model="form.firstUrl"
            @on-change="changeFirstUrl"
            style="width: 300px"
          />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            style="width: 100px; margin-right: 5px"
            :loading="loading"
            @click="saveEdit"
            >保存</Button
          >
        </FormItem>
      </Form>
    </Card>
  </div>
</template>

<script>
import uploadPicThumb from "@/components/upload-pic-thumb";
import {
  getThemeSettingById,
  insertOrUpdate,
  getAllThemeSetting,
} from "@/api/index";
export default {
  name: "ThemeSetting",
  components: { uploadPicThumb },
  name: "sysInfo",
  data() {
    return {
      loading: false,
      accessToken: {},
      form: {
        leftSetting: "light",
        topSetting: "primary",
        logoUrl: "",
        fontSize: "",
        systemName: "",
        firstUrl: "home",
        id: "",
      },
      themeId: "",
    };
  },
  beforeDestroy() {
    // 重新加载主题
    // console.log(localStorage.theme);
    // this.$store.commit("setTheme", localStorage.theme);
  },
  methods: {
    changeFontSize(v) {
      this.$store.commit("setFontSize", v.target.value);
    },
    changeSysName(v) {
      this.$store.commit("setSysName", v.target.value);
    },
    changeLogo(v) {
      this.$store.commit("setLogoUrl", v);
    },
    changeMenuTheme(v) {
      this.form.leftSetting = v;
      this.$store.commit("setMenuTheme", v);
    },
    changeNavTheme(v) {
      this.form.topSetting = v;
      this.$store.commit("setNavTheme", v);
    },
    changeShowTags(v) {
      this.form.showTags = v;
      this.$store.commit("setShowTags", v);
    },
    changeFirstUrl(v) {
      this.$store.commit("setFirstUrl", v);
    },
    init() {
      this.accessToken = {
        accessToken: this.getStore("accessToken"),
      };
    },
    saveEdit() {
      // console.log(this.form);
      // this.$store.commit("saveTheme", this.form);
      insertOrUpdate(this.form).then((res) => {
        this.loading = false;
        if (res.success) {
          this.$Message.success("保存成功");
          this.$store.commit("saveTheme");
          localStorage.setItem(
            "theme",
            JSON.stringify(this.$store.state.theme.theme)
          );
        }
      });
    },
    getInfo() {
      this.form.id = this.userId;
      getAllThemeSetting().then((res) => {
        if (res.success) {
          if (res.result.length > 0) {
            this.form = res.result[0];
            // 更新信息
            this.$store.commit("setNavTheme", this.form.topSetting);
            this.$store.commit("setMenuTheme", this.form.leftSetting);
            this.$store.commit("setLogo", this.form.logoUrl);
            this.$store.commit("setSysName", this.form.systemName);
            this.$store.commit("setFontSize", this.form.fontSize);
            this.$store.commit("setShowTags", this.form.showTags);
            this.$store.commit("setFirstUrl", this.form.firstUrl);
          } else {
            localStorage.removeItem("theme");
          }
        }
      });
    },
  },
  computed: {
    mainTheme() {
      return this.$store.state.theme.theme.mainTheme;
    },
    menuTheme() {
      return this.$store.state.theme.theme.menuTheme;
    },
    navTheme() {
      return this.$store.state.theme.theme.navTheme;
    },
    logoUrl() {
      return this.$store.state.theme.theme.logoUrl
        ? this.$store.state.theme.theme.logoUrl
        : "";
    },
    fontSize() {
      return this.$store.state.theme.theme.fontSize;
    },
    sysName() {
      return this.$store.state.theme.theme.sysName;
    },
    menuWidth() {
      return this.$store.state.theme.theme.menuWidth;
    },
    fixNav() {
      return this.$store.state.theme.theme.fixNav;
    },
    navType() {
      return this.$store.state.theme.theme.navType;
    },
    showTags() {
      return this.$store.state.theme.theme.showTags;
    },
    showNavMenuIcon() {
      return this.$store.state.theme.theme.showNavMenuIcon;
    },
    navShowType() {
      return this.$store.state.theme.theme.navShowType;
    },
    showFold() {
      return this.$store.state.theme.theme.showFold;
    },
    showLogoUrl() {
      return this.$store.state.theme.theme.showLogoUrl;
    },
    showSearch() {
      return this.$store.state.theme.theme.showSearch;
    },
    showFooter() {
      return this.$store.state.theme.theme.showFooter;
    },
    weakMode() {
      return this.$store.state.theme.theme.weakMode;
    },
    userId() {
      return JSON.parse(localStorage.getItem("userInfo")).id;
    },
    orgId() {
      return JSON.parse(localStorage.getItem("userInfo")).tenantOrgId;
    },
  },
  mounted() {
    this.$store.commit("saveTheme");
    localStorage.setItem(
      "theme",
      JSON.stringify(this.$store.state.theme.theme)
    );

    this.getInfo();
    this.init();
    this.form.leftSetting = this.menuTheme;
    this.form.topSetting = this.navTheme;
    this.form.logoUrl = this.logoUrl;
    this.form.fontSize = this.fontSize;
    this.form.systemName = this.sysName;
  },
};
</script>
<style lang="less" scoped>
.theme-item-content {
  margin-bottom: 8px;
}
.title {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 22px;
}
.checkbox-content {
  display: flex;
  flex-wrap: wrap;
  min-height: 42px;
}
.checkbox-item {
  position: relative;
  width: 44px;
  height: 36px;
  margin: 0 16px 16px 0;
  overflow: hidden;
  background-color: #f0f2f5;
  border-radius: 4px;
  box-shadow: 0 1px 2.5px 0 rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.checkbox-select-icon {
  position: absolute;
  right: 5px;
  bottom: 2px;
  color: #1890ff;
  font-weight: 700;
  font-size: 16px;
  pointer-events: none;
}
.checkbox-item:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 33%;
  height: 100%;
  background-color: #fff;
  content: "";
}
.checkbox-item:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 25%;
  background-color: #fff;
  content: "";
}
// light
.checkbox-item-light:before {
  background-color: #fff;
}
.checkbox-item-light:after {
  background-color: #fff;
}
.checkbox-item-primary:after {
  background-color: #005ddb;
}
// darkblue
.checkbox-item-darkblue:before {
  z-index: 1;
  background-color: #002b88;
}
// black
.checkbox-item-black:before {
  z-index: 1;
  background-color: #1f1f1f;
}
// dark
.checkbox-item-dark:before {
  z-index: 1;
  background-color: rgb(81, 90, 110);
}
// 暗黑
.checkbox-item-darkMode {
  background-color: rgba(0, 21, 41, 0.85);
}
.checkbox-item-darkMode:before {
  background-color: rgba(0, 21, 41, 0.65);
}
.checkbox-item-darkMode:after {
  background-color: rgba(0, 21, 41, 0.85);
}
// topright
.checkbox-item-topright:before {
  z-index: 1;
  background-color: #fff;
}
.checkbox-item-topright:after {
  background-color: #001529;
}
// top
.checkbox-item-top:after {
  background-color: #001529;
}
// side-light
.checkbox-item-side-light {
  background-color: #f0f2f5;
}
.checkbox-item-side-light:before {
  z-index: 1;
  background-color: #fff;
}
.checkbox-item-side-light:after {
  background-color: #f0f2f5;
}
// nav
.checkbox-item-nav:before {
  background-color: #f0f2f5;
}
// nav-light
.checkbox-item-nav-light:after {
  z-index: 1;
  background-color: #fff;
}
// nav-darkblue
.checkbox-item-nav-darkblue:after {
  z-index: 1;
  background-color: #002b88;
}
// nav-black
.checkbox-item-nav-black:after {
  z-index: 1;
  background-color: #1f1f1f;
}
// nav-primary
.checkbox-item-nav-primary:after {
  z-index: 1;
  background-color: #2d8cf0;
}
.theme-list {
  display: flex;
  flex-direction: column;
  .theme-list-item {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    //   .item-title {
    //   }
  }
}
.ivu-divider-horizontal {
  margin: 16px 0;
}
.ivu-alert-with-icon {
  padding: 8px 10px 8px 38px;
}
</style>
